import {textSizes} from '@stencil/build-theme';
import styled from 'styled-components';

export const ElitePackageTagWrapper = styled.div`
  position: absolute;
  left: 1rem;
  top: -1.4rem;
`;

export const MainOuterWrapper = styled.div`
  margin-top: 0.8rem;
  border: 0.1rem solid transparent;
  background:
    linear-gradient(#fff, #fff) content-box,
    linear-gradient(
        95.22deg,
        rgba(140, 103, 28, 0.7) 0%,
        rgba(211, 170, 83, 0.7) 26.96%,
        rgba(255, 239, 207, 0.7) 56.52%,
        rgba(211, 170, 83, 0.7) 78.3%,
        rgba(140, 103, 28, 0.7) 101.62%
      )
      border-box;
  border-radius: 1.2rem;
  overflow: hidden;
`;

export const MainWrapper = styled.div`
  padding: 1.4rem;
  /* border-radius: 1.2rem; */
  background: linear-gradient(116.93deg, rgba(255, 255, 255, 0) 54.92%, #fff6e5 88.15%);
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderText = styled.h5`
  background-image: linear-gradient(94.77deg, #d3aa53 0%, #6b4905 100%);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  ${textSizes.BaseW2};
`;

export const ListWrapper = styled.ul`
  ${props => (props.isDweb ? `margin-top: 0.5rem;` : `margin-top: 1rem;`)};
`;

export const ListIconWrapper = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.6rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ListItemDesc = styled.p`
  color: #4a4a4a;
  ${textSizes.SmallW1};
`;
